import React, { useEffect, useState } from "react";
import { message, Table, Modal, Input } from "antd";
import { get, patch } from "../../api/axios";
import { Pagination } from "antd";
import SearchBar from "../../utils/SearchBar";
const Payouts = () => {
  // render: (role) => (role == null ? "" : role.name),
  const columns = [
    //بيانات الحجز
    // 1
    {
      title: (
        <>
          بيانات الحجز
          <br />
          رقم الحجز
          <br />
          اسم الوحدة
          <br />
          رقم الوحدة
          <br />
        </>
      ),

      render: ({ invoice_id, property }) => (
        <>
          {invoice_id || "-"} <br />
          {property?.name || "-"} <br />
          {property?.id || "-"} <br />
          <br />
        </>
      ),
    },

    //بيانات الضيف
    // 2
    {
      title: (
        <>
          بيانات الضيف
          <br />
          أسم الضيف
          <br />
          البريد الالكتروني
          <br />
          الجوال
          <br />
          رقم الضيف
          <br />
        </>
      ),
      dataIndex: "user",
      render: (user) => {
        const { name, phone, email, id } = user || {};
        return (
          <span>
            {name || "-"}
            <br />
            {email || "-"}
            <br />
            {phone || "-"}
            <br />
            {id || "-"}
          </span>
        );
      },
    },

    //بيانات المضيف
    //3
    {
      title: (
        <>
          بيانات المضيف
          <br />
          الاسم
          <br />
          الجوال
          <br />
          البريد الالكتروني
          <br />
          رقم المضيف
          <br />
        </>
      ),
      dataIndex: "owner",
      render: (owner) => {
        const { name, phone, email, id } = owner || {};

        return (
          <span>
            {name || "-"}
            <br />
            {email || "-"}
            <br />
            {phone || "-"}
            <br />
            {id || "-"}
          </span>
        );
      },
    },

    //البيانات البنكية
    //4
    {
      title: (
        <>
          البيانات البنكية
          <br />
          طريقة استلام المبلغ
          <br />
          اسم صاحب الحساب
          <br />
          البنك <br />
          رقم الايبان
          <br />
        </>
      ),

      render: ({ payment_method, owner_name, bank }) => (
        <span>
          {payment_method?.label || "غير متوفر"}
          <br />
          {owner_name || "غير متوفر"}
          <br />

          {payment_method.type === "bank_account" ? (
            <>
              {bank?.name_ar} <br />
              {bank?.iban || "غير متوفر"}
            </>
          ) : (
            <> - </>
          )}
        </span>
      ),
    },

    //بيانات الحوالة
    //5
    {
      title: (
        <>
          بيانات الحوالة
          <br />
          رقم الحوالة
          <br />
          تاريخ انشاء الحوالة
          <br />
          انشاء الحوالة بواسطة
          <br />
          مبلغ الحوالة
          <br />
          تاريخ تنفيذ الحوالة
          <br />
          تنفيذ الحوالة بواسطة
          <br />
          حالة الحوالة
        </>
      ),

      render: ({
        amount,
        payment_method,
        owner_name,
        created_at,
        bank,
        id,
        created_by,
        paid_at,
        payout_status,
        paid_by,
      }) => (
        <span>
          {`TRN${id}` || "غير متوفر"}
          <br />
          {owner_name || "غير متوفر"}
          <br />
          {created_at || "-"}
          <br />
          {created_by || "-"}
          <br />
          {amount || " -"}
          <br />
          {paid_at || " -"}
          <br />
          {paid_by || " -"}
          <br />
          <div>{payout_status || "غير متوفر"}</div>
        </span>
      ),
    },

    //البيانات المالية للتحويل
    //6
    {
      title: (
        <>
          البيانات المالية للتحويل
          <br />
          مبلغ الحوالة
          <br />
          الرسوم
          <br />
          ضريبة رسوم التحويل
          <br />
          رسوم التحويل وضريبتها
          <br />
          البنك المصدر
          <br />
          مرفق الحوالة
          <br />
          ملاحظة
        </>
      ),

      render: ({ amount }) => <span>{amount || " -"}</span>,
    },

    //البيانات عملية للتحويل
    //6
    {
      title: (
        <>
          البيانات عملية للتحويل
          <br />
          الرقم المرجعي
          <br />
          تاريخ الإنشاء
          <br />
          أسم المستفيد
          <br />
          الأسم المختصر
          <br />
          البنك
          <br />
          العملة
          <br />
          السرد{" "}
        </>
      ),

      render: ({ amount }) => <span></span>,
    },

    // {
    //   title: (
    //     <>
    //       طريقة التحويل <br />
    //       اسم صاحب الحساب <br />
    //       البنك <br />
    //       رقم الايبان
    //       <br />
    //     </>
    //   ),
    //   render: ({ payment_method, owner_name, wallet, bank, paid_by }) => (
    //     <span>
    //       {payment_method?.label || "غير متوفر"}
    //       <br />
    //       {owner_name || "غير متوفر"}
    //       <br />
    //       {/* {payment_method.type !== "bank_account" ? (
    //           <>
    //               {wallet || "غير متوفر"}
    //           </>
    //       ) : <> - </>} */}

    //       {payment_method.type === "bank_account" ? (
    //         <>
    //           {bank?.name_ar} <br />
    //           {bank?.iban || "غير متوفر"}
    //         </>
    //       ) : (
    //         <> - </>
    //       )}
    //     </span>
    //   ),
    // },

    {
      title: "تغير الحالة",
      render: ({ payout_status, id }) => (
        <>
          <button
            onClick={() => handleStatus(id)}
            disabled={payout_status === "منفذة" || loadingStates[id]}
            className={`btn ${
              payout_status === "منفذة" ? "btn-primary" : "btn-warning"
            }  py-0`}
          >
            {loadingStates[id]
              ? "Loading..."
              : payout_status === "منفذة"
                ? "منفذة"
                : "قيد التنفيذ"}
          </button>
        </>
      ),
    },

    {
      title: "تحويل",
      render: (record) => (
        <button
          className="btn btn-primary py-0"
          onClick={() => {
            setSelectedPayout(record.id);
            setOpenTransferModal(true);
          }}
        >
          تحويل
        </button>
      ),
    },
  ];

  const [openTransferModal, setOpenTransferModal] = useState(false);
  const [confirmTransferLoading, setConfirmTransferLoading] = useState(false);
  const [selectedPayout, setSelectedPayout] = useState(null);

  const [transferForm, setTransferForm] = useState({
    transfer_amount: "",
    transfer_fee: "",
    transfer_fee_tax: "",
    transfer_fee_with_tax: "",
    source_bank: "",
    transfer_attachment: "",
    note: "",
    reference_number: "",
    creation_date: "",
    beneficiary_name: "",
    short_name: "",
    bank_name: "",
    currency: "",
    narration: "",
  });

  const handleTransferChange = (e) => {
    setTransferForm({
      ...transferForm,
      [e.target.name]: e.target.value,
    });
  };

  const handleTransferSubmit = () => {
    setConfirmTransferLoading(true);

    setTimeout(() => {
      console.log("Transfer Data:", transferForm, "Payout:", selectedPayout);

      setConfirmTransferLoading(false);
      setOpenTransferModal(false);

      setTransferForm({
        transfer_amount: "",
        transfer_fee: "",
        transfer_fee_tax: "",
        transfer_fee_with_tax: "",
        source_bank: "",
        transfer_attachment: "",
        note: "",
        reference_number: "",
        creation_date: "",
        beneficiary_name: "",
        short_name: "",
        bank_name: "",
        currency: "",
        narration: "",
      });
    }, 800);
  };

  const [data, setdata] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedValue, setDebouncedValue] = useState(searchQuery);
  const [total, setTotal] = useState(1);
  const [loadingStates, setLoadingStates] = useState({});
  const handleStatus = (id) => {
    setLoadingStates((prev) => ({ ...prev, [id]: true })); // Set loading for the specific button
    patch(`payouts/${id}`, {}, {})
      .then((res) => {
        message.success("تم تغيير الحالة بنجاح").then((r) => {
          setLoading(true);
          //reload the data
          get(`payouts?search=${searchQuery}`).then((res) => {
            setdata(res?.data.data);
            setTotal(res?.data.meta.last_page);
            setLoading(false);
          });
        });
      })
      .catch((error) => {
        message.error("حدث خطأ أثناء تغيير الحالة");
      })
      .finally(() => {
        setLoadingStates((prev) => ({ ...prev, [id]: false })); // Reset loading for the specific button
      });
  };

  useEffect(() => {
    get(`payouts?search=${searchQuery}`).then((res) => {
      setdata(res?.data.data);
      setTotal(res?.data.meta.last_page);
      setLoading(false);
    });
  }, [debouncedValue]);
  const handlePagination = (pageNumber) => {
    setLoading(true);

    get(`payouts?page=${pageNumber}`).then((res) => {
      setdata(res.data.data);
      setLoading(false);
    });
  };

  return (
    <div>
      <div className="row">
        <SearchBar
          setSearchQuery={setSearchQuery}
          searchQuery={searchQuery}
          debouncedValue={debouncedValue}
          setDebouncedValue={setDebouncedValue}
        />
        <div className="col-12 grid-margin stretch-card">
          <div className="w-100">
            <Table
              locale={{ emptyText: "لا يوجد عناصر" }}
              loading={loading}
              pagination={false}
              bordered
              scroll={{
                y: "65vh",
                x: 1750,
              }}
              columns={columns}
              dataSource={data}
              size="middle"
            />
            <Pagination
              defaultCurrent={1}
              className="mt-4 d-flex align-items-center justify-content-center"
              position="bottomCenter"
              total={total * 10}
              onChange={handlePagination}
            />

            <Modal
              title="تنفيذ تحويل"
              centered
              open={openTransferModal}
              onOk={handleTransferSubmit}
              confirmLoading={confirmTransferLoading}
              onCancel={() => setOpenTransferModal(false)}
              okText="حفظ"
              cancelText="إغلاق"
              width={900}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "20px",
                }}
              >
                {/* RIGHT */}

                <div>
                  <label>مبلغ الحوالة</label>
                  <Input
                    name="transfer_amount"
                    onChange={handleTransferChange}
                  />
                </div>

                <div>
                  <label>الرقم المرجعي</label>
                  <Input
                    name="reference_number"
                    onChange={handleTransferChange}
                  />
                </div>

                <div>
                  <label>الرسوم</label>
                  <Input name="transfer_fee" onChange={handleTransferChange} />
                </div>

                <div>
                  <label>تاريخ الإنشاء</label>
                  <Input
                    type="date"
                    name="creation_date"
                    onChange={handleTransferChange}
                  />
                </div>

                <div>
                  <label>ضريبة رسوم التحويل</label>
                  <Input
                    name="transfer_fee_tax"
                    onChange={handleTransferChange}
                  />
                </div>

                <div>
                  <label>أسم المستفيد</label>
                  <Input
                    name="beneficiary_name"
                    onChange={handleTransferChange}
                  />
                </div>

                <div>
                  <label>رسوم التحويل وضريبتها</label>
                  <Input
                    name="transfer_fee_with_tax"
                    onChange={handleTransferChange}
                  />
                </div>

                <div>
                  <label>الأسم المختصر</label>
                  <Input name="short_name" onChange={handleTransferChange} />
                </div>

                <div>
                  <label>البنك المصدر</label>
                  <Input name="source_bank" onChange={handleTransferChange} />
                </div>

                <div>
                  <label>البنك</label>
                  <Input name="bank_name" onChange={handleTransferChange} />
                </div>

                <div>
                  <label>مرفق الحوالة</label>
                  <Input
                    name="transfer_attachment"
                    onChange={handleTransferChange}
                  />
                </div>

                <div>
                  <label>العملة</label>
                  <Input name="currency" onChange={handleTransferChange} />
                </div>

                <div>
                  <label>ملاحظة</label>
                  <Input name="note" onChange={handleTransferChange} />
                </div>

                <div>
                  <label>السرد</label>
                  <Input name="narration" onChange={handleTransferChange} />
                </div>
              </div>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Payouts;
